import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_public/legal/terms')({
  component: TermsPage,
});

function TermsPage() {
  return (
    <article className="max-w-3xl mx-auto px-6 py-16">
      <h1 className="text-3xl font-semibold text-ink">Términos de Servicio</h1>
      <p className="text-quiet">Última actualización: 24 de abril de 2026</p>

      <h2 className="text-xl font-semibold text-ink mt-10">1. Aceptación</h2>
      <p className="text-body">
        Al usar MEIDEI aceptas estos términos. Si no estás de acuerdo, no uses el servicio.
      </p>

      <h2 className="text-xl font-semibold text-ink mt-8">2. Cuentas</h2>
      <p className="text-body">
        Eres responsable de la seguridad de tu cuenta. Notifícanos de cualquier acceso no
        autorizado.
      </p>

      <h2 className="text-xl font-semibold text-ink mt-8">3. Uso aceptable</h2>
      <p className="text-body">
        No abusar del servicio, no spamear, no subir contenido ilegal. Nos reservamos el derecho a
        suspender cuentas que violen esta política.
      </p>

      <h2 className="text-xl font-semibold text-ink mt-8">4. Planes y pagos</h2>
      <p className="text-body">
        Facturación mensual por adelantado. Sin reembolsos pro-rata por downgrades. Al cancelar,
        mantienes acceso hasta fin del período pagado.
      </p>

      <h2 className="text-xl font-semibold text-ink mt-8">5. Propiedad intelectual</h2>
      <p className="text-body">
        Tus datos son tuyos. Nos concedes licencia mínima para operar el servicio (almacenar,
        procesar, transmitir).
      </p>

      <h2 className="text-xl font-semibold text-ink mt-8">6. Limitación de responsabilidad</h2>
      <p className="text-body">
        El servicio se provee "tal cual". Nuestra responsabilidad se limita al monto pagado en los
        12 meses previos.
      </p>

      <h2 className="text-xl font-semibold text-ink mt-8">7. Cambios</h2>
      <p className="text-body">
        Podemos actualizar estos términos. Cambios materiales se notifican con 30 días de
        anticipación.
      </p>
    </article>
  );
}
